<!--
  Main router element for the report.

  @stable
-->

<router-outlet></router-outlet>
<div class="zef-portal"></div>
